import { Box, ListSubheader } from "@mui/material";
import { ReactNode } from "react";

export type MenuItemsGroupProps = {
  groupTitle: string;
  children: ReactNode;
};

export const BaseSelectMenuGroup = ({
  groupTitle,
  children,
}: MenuItemsGroupProps) => {
  return (
    <Box sx={{ "& + &": { mt: 2 } }}>
      <ListSubheader
        sx={{
          backgroundColor: "background.default",
          px: 3,
          lineHeight: "16px",
          fontSize: "12px",
          pointerEvents: "none",
          textTransform: "uppercase",
        }}
      >
        {groupTitle}
      </ListSubheader>
      {children}
    </Box>
  );
};
